<section class="help-hero">
  <h1>Need <span class="accent">help?</span></h1>

  <div class="help-search-row">
    <div class="help-search">
      <input
        type="text"
        placeholder="Search help articles or ask a question..."
        [(ngModel)]="searchTerm"
        name="helpSearch"
        (ngModelChange)="onSearchInput()"
        (focus)="onSearchFocus()"
        (blur)="onSearchBlur()"
        (keyup.enter)="submitSearch()"
        autocomplete="off"
      />
      <button type="button" class="help-search-send" aria-label="Search" (click)="submitSearch()">
        <i class="fas fa-paper-plane"></i>
      </button>

      <div class="help-suggestions" *ngIf="showSuggestions">
        <button
          type="button"
          class="help-suggestion"
          *ngFor="let faq of suggestions"
          (click)="selectSuggestion(faq)"
        >
          {{ faq.question }}
        </button>
        <p class="help-suggestion-empty" *ngIf="!suggestions.length">
          No matching articles for "{{ searchTerm }}" — try the FAQs below or contact us.
        </p>
      </div>
    </div>

    <span class="help-or">or</span>

    <button type="button" class="help-contact-btn" (click)="scrollToContact()">Contact us</button>
  </div>
</section>
